import { styled } from 'styled-components';

import { media } from '@/utils/mediaQueries';

export const EditBox = styled.div`
    position: absolute;
    top: 15px;
    right: -60px; /* Start offscreen to the right */
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    z-index: 1;
    width:30px;
    height: 30px;
    background: ${({ theme }) => theme.colors.card.background};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')} !important;

    /* Dotyk (brak hover): akcje zawsze widoczne. */
    ${media.touch} {
        right: 15px;
        opacity: 1;
        pointer-events: auto;
    }
`;

export const DeleteBox = styled.div`
    position: absolute;
    top: 35px;
    right: -60px; /* Start offscreen to the right */
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s ease-in-out;
    z-index: 1;
    width:30px;
    height: 30px;
    background: ${({ theme }) => theme.colors.danger[500]};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')} !important;

    /* Dotyk (brak hover): akcje zawsze widoczne. */
    ${media.touch} {
        top: 55px;
        right: 15px;
        opacity: 1;
        pointer-events: auto;
    }
`;

export const EventCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    &:hover ${EditBox} {
        right: 15px;
        top: 15px;
        bottom: auto;
        opacity: 1;
        pointer-events: auto;
        transform: translate(0%, 0%);
    }
    &:hover ${DeleteBox} {
        right: 15px;
        top:55px;
        bottom: auto;
        opacity: 1;
        pointer-events: auto;
        transform: translate(0%, 0%);
    }
`;

export const MoreBox = styled.a`
    position: absolute;
    top: 10px;
    right: 10px;
`;

export const MoreBoxIcon = styled.a`
    width:30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.card.background};
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    opacity: .7;
    &:hover{
        opacity: 1;
    }
`;

export const Cover = styled.div`
    width: 100%;
    height: 150px;
    overflow: hidden;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: ${({ theme }) => theme.colors.primary[200]};
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
        max-width: 100px;
        max-height: 100px;
        height: auto;
    }
`;

export const EventCardBox = styled.div`
    width: 100%;
    height: 80px;
    background: ${({ theme }) => theme.colors.card.background};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? 'rgba(0, 0, 0, 0.3) 0 2px 6px'
    : 'rgba(37, 83, 185, 0.1) 0 2px 6px')} !important;
    padding: 15px 20px;
    position:relative;
    border: 1px solid ${({ theme }) => theme.colors.card.border};
`;

export const Title = styled.h3`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.primary};
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StatusWrapper = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
`;
